import { createSelector } from '@ngrx/store';

import { RootState } from '../root-store/root.state';

export const selectConnectivityFeature = (state: RootState) => state.connectivity;

export const selectExtensa = createSelector(selectConnectivityFeature, (conn) => conn.extensa);

export const selectExtensaConnected = createSelector(selectExtensa, (extensa) => extensa.isConnected);

export const selectExtensaAuth = createSelector(selectExtensa, (extensa) => extensa.auth);

export const selectIsIntegration = createSelector(selectConnectivityFeature, (conn) => conn.isIntegration);

export const selectIsIntegrationAppConnected = createSelector(selectIsIntegration, (is) => is.isConnected);

export const selectSignalr = createSelector(selectConnectivityFeature, (conn) => conn.signalr);

export const selectSignalrConnected = createSelector(selectSignalr, (is) => is.isConnected);

export const selectViewer = createSelector(selectConnectivityFeature, (conn) => conn.viewer);

export const selectViewerConnected = createSelector(selectViewer, (view) => view.isConnected);
